import { useState, useEffect, useMemo } from "react";
import commonStyle from "../common.module.css";
import { booleanObject, datesField, TasksColumnsMaster } from "../../Values/tables";
import { connect, useDispatch } from "react-redux";
import styles from './TaskPanel.module.css';
import Loading from "../../Components/Loading/Loading";
import { getDateString } from "../../Values/utils";
import axios from "axios";
import moment from "moment";
import { url } from "../../Values/constants";
import {
  setFilterObject,
  setRefreshTasks,
  showSnackbarAction,
} from "../../Redux/actions";
import ApiCustomTable from "../../Components/CustomTable/ApiCustomTable";
import ApiTopBar from "../../Components/TopBar/ApiTopBar";
import { themeColors } from "../../Components/theme";
import { useMediaQuery, useTheme } from "@mui/material";
import { taskHeader } from "../../Values/masterHeader";
import { downloadCSVMatser, exportMasterData } from "../../Services/organizations";

let isFinished = false;
const TaskPanelReplicateAdmin = ({
  history,
  user,
  branchUsers,
  filterObject,
  searchString,
  filterSort,
  refreshTasks,
  theme,
  authToken
}: any) => {
  const dispatcher = useDispatch();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const [tasksList, setTasksList] = useState<
    any[] | undefined
  >(undefined);
  const [filterData, setFilterData] = useState<
    any[] | undefined
  >(undefined);
  const [temporaryData, setTemporaryData] = useState<any[]>(
    []
  );
  const [searchQuery, setsearchQuery] = useState("");
  const [status, setStatus] = useState("ALL");
  const [columnModal, setColumnModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>(
    []
  );
  const [selectedRowsData, setSelectedRowsData] = useState<
    any[]
  >([]);
  const [showImportModal, setShowImportModal] =
    useState(false);
  const [uidMap, setUidMap] = useState<any>();

  const [lastPage, setLastPage] = useState(-1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [load, setLoad] = useState(false);
  const [allTasks, setAllTasks] = useState(false);
  const [totalCounts, setTotalCounts] = useState<any>();
  const [filterCount, setFilterCount] = useState<any>({})
  const [searchedItem, setsearchedItem] = useState("");
  const [clearFilterTable, setClearFilterTable] = useState(false);

  const tasksColumns = useMemo(
    () => TasksColumnsMaster(taskHeader),
    [taskHeader]
  );

  useEffect(() => {
  }, [searchString]);

  const handleClearFilter = () => {
    setClearFilterTable(prev => !prev);
  };

  const callApi = async (
    paginate?: boolean,
    localPageSize?: Number,
    localPage?: Number
  ) => {
    if (isFinished === true) {
      return;
    } else {
      setLoad(true);
      const filters: { [key: string]: any[] } = {};
      let feild;
      filters["transfer_status"] = [false];
      Object.keys(filterObject).forEach((item) => {
        if (filterObject && filterObject[item].length > 0) {
          if (item === "is_button_called" || item === "transfer_status" || item === "associate_status" || item === "source_status" || item === "unique_meeting" || item === "unique_site_visit") {
            if (filterObject[item].length === 2) {
              filters[item] = [true, false];
            } else {
              filters[item] =
                filterObject[item][0] === "True" ? [true] : [false];
            }
          } else {
            if (item === "contact_no") {
            } else filters[item] = filterObject[item];
          }
        }
      });
      if (searchString === "") {
        feild = "contact_no";
      } else {
        if (searchString.match(/^[0-9]+$/) != null) {
          feild = "contact_no";
        } else {
          feild = "customer_name";
        }
      }
      let records = localPageSize
        ? localPageSize
        : pageSize;
      const apiData = {
        page: localPage ? localPage : page + 1,
        searchString: searchString,
        sort:
          Object.keys(filterSort).length === 0
            ? { created_at: "-1" }
            : filterSort,
        pageSize: localPageSize ? localPageSize : pageSize,
        filter: filters,
      };
      setFilterCount(filters)

      try {
        axios.defaults.headers.common["x-access-token"] =
          authToken
        const res = await axios.post(
          url + "/tasks/maskMasterSearch",
          apiData
        );
        let data: any[] = res.data;
        const recordsNum = typeof records === "number" ? records : Number(records);
        if (data.length < recordsNum && paginate) {
          isFinished = true;
          setLastPage(page);
        }

        data.forEach((task) => {
          if (task.status === "Pending" && task.due_date < new Date().toISOString()) {
            task.status = "Overdue";
          }
          task.contactId = task.leadId;
          Object.keys(task).forEach((key) => {
            if (
              datesField.includes(key) &&
              task[key] !== ""
            ) {
              if (task[key] !== null) {
                task[key] = moment(task[key]);
              } else {
                task[key] = "";
              }
            }
          });
        });
        if (paginate && filterData) {
          let newData = [...filterData, ...data];
          setFilterData(newData);
          setLoad(false);
        } else {
          setFilterData(data);
          setLoad(false);
        }
      } catch {
        setFilterData([]);
        setLoad(false);
        dispatcher(
          showSnackbarAction("Please Try Again!!", "error")
        );
      }
    }
  };

  useEffect(() => {
    if (user === undefined) {
      setFilterData([]);
      return;
    }
    isFinished = false;
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if (authToken) {
      callApi(false, pageSize, 1);
    }
  }, [
    user,
    filterObject,
    filterSort,
    searchString,
    allTasks,
    authToken
  ]);

  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if (authToken) {
          callApi(false, pageSize);
        }
      } else {
        if (authToken) {
          callApi(true, pageSize);
        }
      }
    }
  }, [page, pageSize, authToken]);

  useEffect(() => {
    if (user === undefined) {
      setFilterData([]);
      return;
    }
    if (authToken) {
      callCountApi();
    }
  }, [refreshTasks, filterCount, authToken]);

  const callCountApi = async () => {
    axios.defaults.headers.common["x-access-token"] =
      authToken
    const res = await axios.post(url + "/tasks/MasterContactCount", {
      leadFilter: filterCount
    });

    setTotalCounts(res.data.total);
  };

  useEffect(() => {
    if (refreshTasks === true) {
      if (authToken) {
        callApi();
        getTasksFilter();
        dispatcher(setRefreshTasks(false));
      }
    }
  }, [refreshTasks, authToken]);

  const getTasksFilter = async () => {
    axios.defaults.headers.common["x-access-token"] =
      authToken
    const res = await axios.post(
      url + "/tasks/MasterFilterValues",
      {}
    );
    if (res.data[0]) {
      dispatcher(
        setFilterObject({
          ...res.data[0],
          ...booleanObject,
          status: ["Pending", "Overdue", "Completed"],
        })
      );
    } else {
      dispatcher(setFilterObject({}));
    }
  };

  useEffect(() => {
    if (user === undefined) {
      return;
    }
    if (authToken) {
      getTasksFilter();
    }
  }, [user, authToken]);

  const exportFile = () => {
    if (!selectedRowsData?.length) {
      dispatcher(showSnackbarAction("No rows selected!", "error"));
      return;
    }
    const exportData = exportMasterData(selectedRowsData, tasksColumns);
    if (!exportData.length) {
      dispatcher(showSnackbarAction("No data available for export!", "error"));
      return;
    }
    downloadCSVMatser(exportData,"TasksExport");
    dispatcher(showSnackbarAction("Exported successfully!", "success"));
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: isMobile ? "6%" : "4%", ...containerStyles }}>
        {load === true && <Loading />}
        <div className={commonStyle.topBar} style={{ marginTop: "0px", ...containerStyles }}>
          <ApiTopBar
            history={history}
            title={"Add Task"}
            path={"/addTasks"}
            onClick={() => {
              setShowImportModal(true);
            }}
            onChange={(val) => setsearchedItem(val)}
            filterText={"Status"}
            setColumnModal={(data) => setColumnModal(data)}
            show={true}
            showStatusBox={false}
            onExport={exportFile}
            searchedString={searchString}
            clearFilter={handleClearFilter}
            role="Admin"
          />
        </div>
        <div className={commonStyle.parent} style={{ minHeight: "450px", ...containerStyles }}>
          <ApiCustomTable
            tableColumns={tasksColumns}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="Task"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) =>
              setSelectedRowsData(data)
            }
            setPage={(val) => setPage(val)}
            setPageSize={(val) => setPageSize(val)}
            callApi={callApi}
            pageSize={pageSize}
            page={page}
            isFinished={isFinished}
            totalCount={totalCounts}
            lastPage={lastPage}
            clearFilterTable={clearFilterTable}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    branchUsers: state.branchUsers.data,
    filterObject: state.filter,
    filterSort: state.filterSort,
    searchString: state.searchItem.tasksSearchString,
    refreshTasks: state.refresh.refreshTasks,
    theme: state.theme.isLightMode,
    authToken: state.user.authToken,
  };
};

export default connect(mapStateToProps)(TaskPanelReplicateAdmin);
